module.exports = __webpack_public_path__ + "img/hange.8bf63ed7.png";